import { IApplicationState } from '@Site/rootReducer'
import every from 'lodash/every'
import filter from 'lodash/filter'
import map from 'lodash/map'
import { createSelector } from 'reselect'

import {
  IAccountUser
} from '@SiteModules/AccountUser/types'

export const getHasLoadedInitially = (state: IApplicationState): boolean => state.accountUsers.hasLoadedInitially

export const getLoading = (state: IApplicationState): boolean => state.accountUsers.loading

export const getAccountUsers = (state: IApplicationState): IAccountUser[] => state.accountUsers.accountUsers

export const getSelectedAccountUserIds = (state: IApplicationState): number[] => state.accountUsers.selectedAccountUserIds

export const getAllAccountUsersSelected = createSelector(
  [getSelectedAccountUserIds, getAccountUsers],
  (selectedAccountUserIds, accountUsers) => every(accountUsers, accountUser => selectedAccountUserIds.includes(accountUser.id))
)

export const getSelectedAccountUsers = createSelector(
  [getSelectedAccountUserIds, getAccountUsers],
  (selectedAccountUserIds, accountUsers) => filter(accountUsers, accountUser => selectedAccountUserIds.includes(accountUser.id))
)

export const getSelectedAccountUserUserIds = createSelector(
  [getSelectedAccountUsers],
  (selectedAccountUsers) => map(selectedAccountUsers, selectedAccountUser => selectedAccountUser.attributes.userId)
)
